import DTO from '../DTO';

export default function ObjectType(config) {
  return function ObjectType(data) {
    return new DTO(config, data);
  };
}
